export interface Profile {
  icon: string
  who: string
  situation: string
  benefit: string
}

/** "C'est pour vous si…" — avatar profiles of the product (not customer reviews). */
export const profiles: Profile[] = [
  {
    icon: '🔧',
    who: 'Mécanicien ou technicien d’atelier',
    situation:
      'Garage indépendant, concession ou centre auto : les pannes s’enchaînent et un code lu trop vite peut envoyer sur une mauvaise piste.',
    benefit: 'Un ordre de diagnostic identique à chaque véhicule, du symptôme à la validation.',
  },
  {
    icon: '🎓',
    who: 'Apprenti ou élève en CAP / Bac Pro Maintenance des véhicules',
    situation: 'Entre les cours et l’atelier, il est difficile de savoir par où commencer devant une panne.',
    benefit: 'Des fiches, des procédures guidées et des cas pratiques corrigés, module par module.',
  },
  {
    icon: '📘',
    who: 'Étudiant en BTS Maintenance des véhicules',
    situation: 'Vous devez structurer votre raisonnement et rédiger des comptes rendus d’intervention clairs.',
    benefit: 'La méthode SYMPTÔME › CODES › MESURES › HYPOTHÈSE › VALIDATION appliquée partout.',
  },
  {
    icon: '⚙️',
    who: 'Mécanicien autodidacte',
    situation: 'Vous savez démonter et remonter, mais le diagnostic électronique et électrique reste flou.',
    benefit: 'Des tableaux de contrôle et des guides de mesure pour diagnostiquer avec méthode.',
  },
  {
    icon: '🚗',
    who: 'Passionné qui entretient son véhicule',
    situation: 'Un voyant s’allume, un bruit apparaît : vous voulez comprendre avant de changer une pièce.',
    benefit: 'Une référence claire pour vérifier dans le bon ordre et éviter les essais au hasard.',
  },
]
